import { Search, Lightbulb, Rocket, TrendingUp, CheckCircle, ArrowRight, MessageCircle } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Reveal } from "@/components/Reveal";

export const ProcessSection = () => {
  const steps = [
    {
      number: "01",
      icon: Search,
      title: "AUDITORÍA",
      items: [
        "Análisis de situación actual",
        "Identificación de oportunidades",
        "Recomendaciones iniciales"
      ]
    },
    {
      number: "02",
      icon: Lightbulb,
      title: "ESTRATEGIA",
      items: [
        "Plan personalizado",
        "Objetivos claros y medibles",
        "Definición de acciones"
      ]
    },
    {
      number: "03",
      icon: Rocket,
      title: "PRODUCCIÓN & EJECUCIÓN",
      items: [
        "Creación de contenido",
        "Implementación de campañas",
        "Optimización continua"
      ]
    },
    {
      number: "04",
      icon: TrendingUp,
      title: "REPORTES & OPTIMIZACIÓN",
      items: [
        "Reportes claros y accionables",
        "Análisis de métricas clave",
        "Ajustes continuos basados en datos"
      ]
    }
  ];

  return (
    <section id="process" className="py-12 sm:py-16 lg:py-20 px-4 sm:px-6 lg:px-8 bg-muted/30">
      <div className="max-w-7xl mx-auto">
        <Reveal className="text-center mb-10 sm:mb-12 lg:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-primary mb-4 sm:mb-6">
            Nuestro Proceso de Trabajo
          </h2>
          <p className="text-base sm:text-lg lg:text-xl text-primary max-w-2xl lg:max-w-3xl mx-auto px-2">
            Un proceso estructurado con comunicación constante
          </p>
        </Reveal>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-5 lg:gap-6 mb-8 sm:mb-10 lg:mb-12">
          {steps.map((step, index) => {
            const IconComponent = step.icon;
            return (
              <Reveal key={index} delay={Math.min(index + 1, 6)}>
                <Card className="group relative overflow-hidden hover-lift border-border hover:border-accent bg-card h-full">
                  <CardContent className="relative p-4 sm:p-5 lg:p-6">
                    <div className="text-4xl sm:text-5xl lg:text-6xl font-bold text-primary/20 mb-3 sm:mb-4">
                      {step.number}
                    </div>

                    <div className="mb-3 sm:mb-4">
                      <div className="p-2.5 sm:p-3 bg-primary/30 rounded-xl w-fit group-hover:bg-primary/45 transition-all duration-300">
                        <IconComponent className="h-6 sm:h-7 lg:h-8 w-6 sm:w-7 lg:w-8 text-primary" />
                      </div>
                    </div>

                    <div className="mb-3 sm:mb-4">
                      <h3 className="text-base sm:text-lg lg:text-xl font-bold text-accent mb-1.5 sm:mb-2 transition-colors">
                        {step.title}
                      </h3>
                    </div>

                    <ul className="space-y-2 sm:space-y-3">
                      {step.items.map((item, itemIndex) => (
                        <li key={itemIndex} className="flex items-start">
                          <CheckCircle className="h-3.5 sm:h-4 w-3.5 sm:w-4 text-primary mr-2 flex-shrink-0 mt-0.5" />
                          <span className="text-xs sm:text-sm text-foreground/85">{item}</span>
                        </li>
                      ))}
                    </ul>

                    {index < steps.length - 1 && (
                      <div className="hidden lg:block absolute -right-3 top-1/2 -translate-y-1/2 z-10">
                        <ArrowRight className="h-5 lg:h-6 w-5 lg:w-6 text-primary/40" />
                      </div>
                    )}
                  </CardContent>
                </Card>
              </Reveal>
            );
          })}
        </div>

        <Reveal delay={5}>
          <div className="flex items-center justify-center py-8 mt-4">
            <Button 
              size="lg"
              className="bg-primary hover:bg-primary-hover text-primary-foreground px-6 py-3 font-semibold rounded-full shadow-md shadow-primary/15 hover:shadow-primary/25 transition-all hover-lift group relative overflow-hidden"
              onClick={() => {
                window.open(`https://wa.me/50670473873?text=${encodeURIComponent("Hola! Me gustaría agendar mi diagnóstico.")}`, '_blank');
              }}
            >
              <span className="relative z-10 flex items-center">
                <MessageCircle className="mr-2 h-5 w-5" />
                Agendá una llamada
              </span>
            </Button>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
